/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Control from '../Control/Control';
import './Comment.css';

/**
 * Represents the comment component.
 */

export default class Comment extends Control {

    /**
     * Properties.
     */

    static propTypes = {
        text:               PropTypes.string.isRequired,
        width:              PropTypes.number
    }

    /**
     * Gets the style of the comment.
     * 
     * @return  {Object}    style   style of the comment
     */

    getStyle = () => {

        // Preparing

        let style = this._getStyle();
        
        // Adding style attributes
        
        style.width = this.props.width + 'px';

        // Returns the style

        return style;
    }
    
    /**
     * Comment renderer.
     */

    render() {
        return (
            <div className="comment" style={this.getStyle()}>{this.props.text}</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Comment/Comment.js